<rc-order>
  <span order-heading>
    <span class="material-icons error-icon">error</span>
    Plata pentru comanda #{{orderId}} a eșuat
  </span>
  <span order-content>
    <div class="failure-message">
      <p class="primary-message">Ne pare rău, plata nu a fost efectuată cu succes.</p>
      <p class="secondary-message">
        Acest lucru se poate întâmpla din diverse motive: fonduri insuficiente, date de card incorecte,
        sau probleme temporare cu procesatorul de plăți.
      </p>
    </div>
  </span>
  <span thanks-content>
    <div class="action-section">
      <h3 class="section-title">Ce poți face în continuare?</h3>

      <!-- Error message section -->
      <div *ngIf="errorMessage" class="error-alert">
        <mat-icon class="error-alert-icon">warning</mat-icon>
        <p class="error-alert-message">{{ errorMessage }}</p>
      </div>

      <div class="options-container">
        <div class="option-card primary-option">
          <div class="option-icon">
            <mat-icon>refresh</mat-icon>
          </div>
          <div class="option-content">
            <h4>Încearcă din nou</h4>
            <p>Verifică datele cardului și încearcă din nou plata online</p>
            <button mat-raised-button
                    (click)="retryPayment()"
                    [disabled]="isRetryingPayment"
                    color="primary"
                    class="action-button primary-button"
                    gaEvent="payment_failed_retry"
                    gaCategory="buttons_tracking">
              <mat-icon>{{isRetryingPayment ? 'hourglass_empty' : 'credit_card'}}</mat-icon>
              {{isRetryingPayment ? 'Se procesează...' : 'Plătește din nou'}}
            </button>
          </div>
        </div>

        <div class="option-card secondary-option">
          <div class="option-icon">
            <mat-icon>account_balance</mat-icon>
          </div>
          <div class="option-content">
            <h4>Transfer bancar</h4>
            <p>Efectuează plata prin transfer bancar folosind factura trimisă pe e-mail</p>
            <div class="bank-info">
              <small>Vei primi instrucțiuni detaliate pe e-mail în câteva minute</small>
            </div>
          </div>
        </div>
      </div>

      <div class="help-section">
        <p class="help-text">
          <mat-icon class="help-icon">help_outline</mat-icon>
          Ai întrebări? Contactează-ne la
          <a [href]="'tel:' + phoneRaw" class="contact-link">{{phone}}</a>
          sau
          <a [href]="'mailto:' + email" class="contact-link">{{email}}</a>
        </p>
      </div>
    </div>
  </span>
</rc-order>
